module.exports = __webpack_public_path__ + "img/knu2_gallery13.7e3f3f87.jpg";